export default "__VITE_ASSET__CKik9NI3__"